import { NoticeReadModel } from '@/types';
/**
 * @description 获取律协、律所名称以中文“、”隔开的字符串
 */
export const getCompanyName = (company: Array<NoticeReadModel>) => {
  if (!company.length) return;
  const list = company.map(item => item.recipientName);
  return list.join('、');
};
